var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ current: _vm.active }},[_c('router-link',{attrs:{"to":{ name: 'BookingInventoryProduct' }}},[_c('i',{staticClass:"fa fa-cubes"}),_vm._v(" Inventory")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }